import IpubRow from './src/main'

/* istanbul ignore next */
IpubRow.install = function(Vue) {
  Vue.component(IpubRow.name, IpubRow)
}

export default IpubRow
